import { render } from "./pill.vue?vue&type=template&id=7b18b4ac&scoped=true"
import script from "./pill.vue?vue&type=script&lang=js"
export * from "./pill.vue?vue&type=script&lang=js"

import "./pill.vue?vue&type=style&index=0&id=7b18b4ac&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b18b4ac"]])

export default __exports__